import React, { useEffect } from 'react';
import { MessageRepository, ChannelRepository } from '@amityco/js-sdk';
import MessageList from '../../../chat/components/MessageList';
import MessageComposeBar from '../../../chat/components/MessageComposeBar';
import customizableComponent from '../../../core/hocs/customization';
import ChatHeader from '../../../chat/components/ChatHeader';
import { ChannelContainer } from './styles';
const channelRepo = new ChannelRepository();
const Chat = ({ channelId, onChatDetailsClick, shouldShowChatDetails }) => {
    useEffect(() => {
        var _a;
        const channelLiveObject = channelRepo.joinChannel({ channelId });
        // TODO call startReading once on join, everytime a new message is received and a message list is scrolled to very bottom
        if ((_a = channelLiveObject.model) === null || _a === void 0 ? void 0 : _a.membership) {
            channelLiveObject.model.membership.startReading();
        }
        channelLiveObject.on('dataUpdated', (channelModel) => {
            if (!(channelModel === null || channelModel === void 0 ? void 0 : channelModel.membership)) {
                return;
            }
            channelModel.membership.startReading();
        });
        return () => {
            var _a;
            if ((_a = channelLiveObject === null || channelLiveObject === void 0 ? void 0 : channelLiveObject.model) === null || _a === void 0 ? void 0 : _a.membership) {
                channelLiveObject.model.membership.stopReading();
            }
            channelLiveObject.dispose();
        };
    }, [channelId]);
    const sendMessage = (text) => {
        MessageRepository.createTextMessage({
            channelId,
            text,
        });
    };
    return (React.createElement(ChannelContainer, null,
        React.createElement(ChatHeader, { channelId: channelId, shouldShowChatDetails: shouldShowChatDetails, onChatDetailsClick: onChatDetailsClick }),
        React.createElement(MessageList, { channelId: channelId }),
        React.createElement(MessageComposeBar, { onSubmit: sendMessage })));
};
export default customizableComponent('Chat', Chat);
//# sourceMappingURL=index.js.map